import { useSearchParams, useLocation } from 'react-router-dom';

const Config = require('Config');

// TODO: Consider moving to config file.
export const internalDomains = [
  'protransport.co',
  'pro-transport.com',
  'rtscareers.com',
  'rtscarrierservices.com',
  'rtscredit.com',
  'rtsfinancial.com',
  'rtsinternational.com',
  'ryanrts.com',
  'ryantrans.com',
  'shamrocktradingcorp.com',
];

export const isInternal = (email: string) => internalDomains.some((domain) => email.includes(domain));

const localhostArr = ['localhost', '127.0.0.1'];
const validDevOrLocalhostArr = [...localhostArr, 'ryanrtsdev.com', 'rtspro.dev'];
const validDestinationArr = ['ryanrtsdev.com', 'ryanrts.com', 'rtspro.dev', 'rtspro.com'];
const hostnameRegex = (arr: string[]) => new RegExp(`^(?:[a-zA-Z0-9-]+\\.)*(${arr.join("|")})$`);

export const validatedFinalDestination = (finalDestination?: string) => {
  if (!finalDestination) return;
  let isValid = false;
  try {
    const destinationUrl = new URL(decodeURIComponent(finalDestination));
    if (hostnameRegex(localhostArr).test(destinationUrl.hostname)) {
      // If redirecting to localhost, valid if also local or in dev
      isValid = hostnameRegex(validDevOrLocalhostArr).test(window.location.hostname);
    } else {
      // Otherwise valid if destinationUrl is in regex allow list
      isValid = hostnameRegex(validDestinationArr).test(destinationUrl.hostname);
    }
  } catch (e) { }
  return isValid ? finalDestination : Config.rtsproHomepage;
}

// Use session service URL as adding a new adfs URL causes duplication issues with Sonarcloud
export const redirectToAdfs = (finaldestination: string = '', username = '') => {
  let loginhint = '';
  if (username) {
    loginhint = (finaldestination ? '&' : '?') + `loginhint=${username}`;
  }

  window.location.replace(
    `${Config.sessionServiceUrl}v2/adfs/auth${finaldestination}${loginhint}`,
  );
};

/**
 * Function to return a series of values as an array based on a Config.
 * This is useful when one when you want to perform array operations on a
 * subset of an objects values based on it's keys.
 * @param {Record<string, unknown>} obj
 * @param {Array<string>} args
 * @return {Array<T>}
 */
export const getValues = <O extends Object, T extends PropertyKey>(obj: O, ...args: Array<keyof O>) =>
  args.map((key) => Reflect.get<O, T>(obj, key as T));

export function extractDomainFromUrl(url: string): string | null {
  const regex = /https:\/\/(.*?)\./;
  const match = url.match(regex);

  if (match && match[1]) {
    return match[1];
  } else {
    return null; // Return null if no match is found
  }
}

export const useFinalDestination = (setRerender) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  return (loginRequest: { token: string; email: string }) => {
    if (searchParams.has('finaldestination')) {
      const [encodedToken, encodedEmail] = getValues<typeof loginRequest, string>(loginRequest, 'token', 'email').map(
        (el) => encodeURIComponent(el),
      );
      const destination = validatedFinalDestination(searchParams.get('finaldestination'));
      const paramSeparator = destination.includes('?') ? '&' : '?';
      window.location.href = `${destination}${paramSeparator}token=${encodedToken}&email=${encodedEmail}`;
      return;
    }
    if (location.pathname === '/auth') {
      window.location.href = `${Config.rtsproHomepage}`;
    } else {
      setRerender(2);
    }
  };
};

export const isErrorObject = (result: unknown): result is { error: unknown } => {
  return (result as { error: unknown }).error !== undefined;
};

export const isMobile = (): boolean => typeof window !== 'undefined' && window.matchMedia('(max-width: 576px)').matches;
